import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BookingStepService } from '../services/booking-step.service';
import { BookingStepEnum } from '../models/booking-step.enum';
import { OrderStateService } from '../../order/services/order-state.service';
import { map } from 'rxjs/operators';

@Injectable()
export class BookingLoginGuard implements CanActivate {

  constructor(
    private bookingStepService: BookingStepService,
    private router: Router,
    private orderStateService: OrderStateService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.orderStateService.isNeedReloadOrder) {
      return this.bookingStepService.initFromLoadOrder(BookingStepEnum.Login)
        .pipe(
          map(_ => {
            return this.isCanActivate();
          }));
    }
    return this.isCanActivate();

  }

  isCanActivate(): boolean {
    if (!this.bookingStepService.isBookingRegistrationAvailable) {
      this.router.navigate(['booking']);
      return false;
    }

    if (this.bookingStepService.isLoggedIn) {
      this.bookingStepService.update(
        BookingStepEnum.Payment
      );
      // this.router.navigate(['payment/start']);
      return false;
    }

    return true;
  }
}
